import { AxiosPromise } from 'axios';
import { urlHelper } from 'src/app/helpers';
import { NSearchLoggerGetAllType } from 'src/app/redux/nSearch/nSearch-slice-type';
import { axios } from 'src/app/utils';
import { finalUrlsConfig } from 'src/configs/url.config';

export const nSearchGenerateLog = (data: any): AxiosPromise<any> => {
  return axios.post(finalUrlsConfig().nSearchLogger.nSearch, data);
};

export interface NSearchLoggerGetAllLogsQueryParams {
  customerIds?: string[];
  actions?: string[];
  startDate?: number;
  endDate?: number;
}

export const getNSearchLogs = async (
  queryParams?: NSearchLoggerGetAllLogsQueryParams,
): AxiosPromise<NSearchLoggerGetAllType> => {
  return axios.get(finalUrlsConfig().nSearchLogger.nSearch, { params: urlHelper.getLookupQuery(queryParams) });
};

export default {
  nSearchGenerateLog,
};
